import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { toggleFeedbackModal } from 'actions/appActions';
import { sendFeedback } from 'actions/asyncActions';

import Input from 'components/common/form/Input';
import Text from 'components/common/form/Text';
import { Field } from 'formik';
import { Button } from 'antd';

import { withAsyncActions } from 'react-async-client';
import withForm from 'components/hocs/withForm';
import yup from 'yup';
  

const validationSchema = yup.object({
    name: yup.string().required().matches(/^[а-яА-ЯЁё -]*$/, 'Допустимы только кириллические буквы'),
    surname: yup.string().required().matches(/^[а-яА-ЯЁё -]*$/, 'Допустимы только кириллические буквы'),
    email: yup.string().email().required(),
    message: yup.string().trim().required().max(1000, `Текст сообщения не должен превышать 1000 символов`),
});

@withAsyncActions({
    sendFeedback
})
@connect(null, { toggleFeedbackModal })
@withForm({
    validationSchema: validationSchema,
    handleSubmit: (values, { props: { sendFeedback, toggleFeedbackModal } }) => {
        sendFeedback.dispatch({ email: values.email, message: values.message });
        toggleFeedbackModal();
    }
})
export default class FeedbackForm extends Component {
    render() {
        return (
            <Fragment>
                    <Field
                        name='name'
                        disabled
                        component={Input}
                    />
                    <Field
                        name='surname'
                        disabled
                        component={Input}
                        placeholder='Фамилия'   
                    />
                    <Field
                        name='email'
                        component={Input}
                        placeholder='Почта для Связи'
                    />
                    <Field
                        name='message'
                        component={Text}
                        placeholder='Текст обращения'
                    />
                    <Button
                        key='submit'
                        type='primary' 
                        htmlType='submit'
                    >
                        Отправить обращение
                    </Button>
            </Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/layout/FeedbackForm.js